import React, {Fragment, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Observable} from 'rxjs';
import {useSocialLogin} from './useSocialLogin';
import {Divider} from '../static';
import {Wrapper as ButtonsWrapper} from '../buttons/wrapper';
import {SocialButton} from '../buttons/social';
import {CONFIG} from 'config/config';

export const SocialLogin = ({formType, errors$, dividerText, registration, forwardReferer, newsletter}) => {
    const [handleSuccess, handleError] = useSocialLogin(formType, errors$, registration, forwardReferer);
    const [appleAvailable, setAppleAvailable]  = useState(false);
    const [failed, setIsFailed] = useState(false);

    useEffect(() => {
        const appleEnabled = window.applicationApple.enabled;
        setAppleAvailable(appleEnabled);

        const handleAppleSuccess = (response) => {
            const data = response.detail;

            handleSuccess('apple', newsletter)({
                token: {
                    accessToken: data.authorization.code,
                    idToken: data.authorization.id_token,
                },
                extras: {
                    firstName: (data.user && data.user.name && data.user.name.firstName) ? data.user.name.firstName : null,
                    lastName: (data.user && data.user.name && data.user.name.lastName) ? data.user.name.lastName : null,
                }
            });
        };

        const handleAppleFailure = (error) => {
            handleError(error.message);
        };

        if (appleEnabled) {
            window.AppleID.auth.init({
                clientId: CONFIG.APP_ID.APPLE || window.applicationApple.serviceId,
                scope: 'name email',
                redirectURI: window.document.location.href,
                state: 'auth_init',
                usePopup: true,
            });

            window.document.addEventListener('AppleIDSignInOnSuccess', handleAppleSuccess);
            window.document.addEventListener('AppleIDSignInOnFailure', handleAppleFailure);
        }

        return () => {
            window.document.removeEventListener('AppleIDSignInOnSuccess', handleAppleSuccess);
            window.document.removeEventListener('AppleIDSignInOnFailure', handleAppleFailure);
        }

    }, []);

    const handleFailure = (err) => {
        handleError(err.message);
        // very ugly hack for stupid RSL lib, this lib is downloading CDN on render component
        // when user dismiss dialog with social login, then CDN disappears and reopening dialog is impossible
        // this hack will force component rerender and with this CDN will appear again
        // probably i'll working well when https://github.com/deepakaggarwal7/react-social-login/pull/122 will be merged
        setIsFailed(true);
        setIsFailed(false);
    };

    const handleAppleSign = () => {
        const {registerModalApplied} = window;

        if (registerModalApplied) {
            return window.location = window.registerPageUrl;
        }

        window.AppleID.auth.signIn();
    };

    return !failed && (
        <Fragment>
            <Divider>{dividerText}</Divider>
            <ButtonsWrapper number={appleAvailable ? 3 : 2}>
                <SocialButton
                    className="btn btn-secondary btm-md form-button facebook"
                    provider="facebook"
                    appId={CONFIG.APP_ID.FACEBOOK || window.applicationFb.appId}
                    scope="public_profile,email"
                    onLoginSuccess={handleSuccess('facebook', newsletter)}
                    onLoginFailure={handleFailure}>
                    <i className="fa fa-facebook-f"/>
                </SocialButton>
                <SocialButton
                    className="btn btn-secondary btm-md form-button google"
                    provider="google"
                    appId={CONFIG.APP_ID.GOOGLE || window.applicationGoogle.appId}
                    onLoginSuccess={handleSuccess('google', newsletter)}
                    onLoginFailure={handleFailure}>
                    <span className="icon-google"/>
                </SocialButton>
                {
                    appleAvailable ? (
                        <button
                            type={'button'}
                            className="btn btn-secondary btm-md form-button apple"
                            onClick={() => handleAppleSign()}>
                            <i className="fab fa-apple"/>
                        </button>
                    ) : <></>
                }
            </ButtonsWrapper>
        </Fragment>
    )
};
SocialLogin.propTypes = () => ({
    formType: PropTypes.oneOf(['login', 'register']).isRequired,
    errors$: PropTypes.instanceOf(Observable).isRequired,
    dividerText: PropTypes.string.isRequired,
});
